import DivisionRepository from "../api/division"
import "../types"

class DivisionUseCase {
    constructor() {
        /** @type {DivisionRepository}*/
        this.api = new DivisionRepository()
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        const {data, err} = await this.api.getAll(queries)
        if (err && err === "record not found") {
          return {data: null, err: null}
        }
        return {data, err}
    }

    /**
     *
     * @param id {number}
     * @return {Promise<{data, err: null}|{data: null, err: ErrorState}>}
     */
    async getOne(id) {
        const {data, err} = await this.api.getOne(id)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }

    /**
     *
     * @param id {number}
     * @param formData {FormData}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
    async editOne(id, formData) {
        return await this.api.editOne(id, formData)
    }

    /**
     *
     * @param formData {FormData}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
    async saveOne(formData) {
        return await this.api.saveOne(formData)
    }
}

export default new DivisionUseCase()
